import React from "react";
import TextField from "@mui/material/TextField";

export default function Input(props) {
  const {
    name,
    label,
    type = "text",
    value,
    error ,
    minRows,
    multiline,
    readonly = false,
    onChange,
    ...other
  } = props;
  return (
    <div>
      <TextField
        variant="outlined"
        label={label}
        type={type}
        name={name}
        minRows={minRows}
        multiline={multiline}
        InputProps={{ inputProps: { min: 0 } }}
        value={value}
        readOnly={readonly}
        onChange={onChange}
        {...other}
        {...(error && { error: true, helperText: error })}
      />
    </div>
  );
}
